import {
  ANALYTICS_FOR_USER,
  CREATE_EDIT_CUSTOMER_USER_ANALYTICS,
} from "./analytics";
import { capitalize } from "lodash";

export const INVITATION_SENT = "Invitation sent";
export const STATUS = "STATUS";
export const CANCEL = "Cancel";
export const NO_APP_VERSIONS_AVAILABLE = "No app versions available";
export const LATEST_VERSION = "Latest version";
export const MINIMUM_VERSION = "Minimum version";
export const ACCOUNT_ACCESS_DENIED_MESSAGE = "Access denied to this account";
export const INVALID_URL_LINK_MESSAGE = "Invalid url link";
export const VERIFICATION_LINK_I_EXPIRED = "Verification link is expired";
export const EMAIL_VERIFIED = "Email verified";
export const CANCEL_EDIT_PROFILE = "Cancel - Edit Profile";
export const CLOSE = "Close";
export const DISABLE = "Disable";
export const RESET_PASSWORD = "RESET PASSWORD";
export const RESET_PASSWORD_MESSAGE = "Password reset successfully";
export const USER_MUST_HAVE_AT_LEAST_ONE_PROFILE =
  "User must have at least one profile";
export const SAVE = "SAVE";
export const YES = "yes";
export const GOT_IT = "I’ve got it";
export const YES_DELETE_IT = "Yes, Delete it";
export const NO = "no";
export const CONTINUE = "Continue";
export const LOCALITY = "Locality";
export const CONFIRM = "Confirm";
export const TOWN_CITY = "Town/City";
export const ACCOUNT_DETAILS = "Account Details";
export const MAINTAIN_USER = "Maintain User";
export const USER_DETAILS = "User Details";
export const ADDITIONAL_ACCOUNTS = "Additional Accounts";
export const IP_RESTRICTIONS = "IP Restrictions";
export const SYSTEM_ACCESS = "System Access";
export const MISCELLANEOUS_CONFIGURATION = "Miscellaneous Configuration";
export const ADVANCED_CUSTOMER_CONFIGURATION =
  "Advanced Customer Configuration";
export const SERVICE_EXCLUSIONS = "Service Exclusions";
export const SECURITY_SETTINGS = "Security Settings";
export const SHIPPING_SETTINGS = "Shipping Settings";
export const SERVICE_XREF_MAPPINGS = "Service Xref Mappings";
export const SERVICE_RESTRICTIONS = "Service Restrictions";
export const INTERNATIONAL_SHIPMENTS = "International shipments";
export const CHANGE_MESSAGE = "Change Message";
export const ADD_KEY = "Add Key";
export const DELETE_KEY = "Delete Key";
export const DISABLE_API_ACCESS = "Disable Api Access";
export const LABEL_SETTINGS = "Label Settings";
export const USER_PROFILES = "User Profiles";
export const API_SETTING = "Api Setting";
export const CREATE_NEW_PASSWORD = "Create your new password";
export const NEXT = "Next";
export const WARNING = "warning";
export const SENDER_ADDRESS = "Sender address";
export const TEL_NO = "Tel No";
export const EMAIL_ADDRESS = "Email Address";
export const OR = "or";
export const LOGIN_USING = "Login using";
export const CREATE_PASSWORD = "Create your password";
export const ORGANISATION_ID = "Organisation ID";
export const SAVE_USER = "Save User";
export const UPDATE_ACCOUNT = "Update Account";
export const DATE_CREATED = "Date Created";
export const LAST_MAINTAINED = "Last Maintained";
export const LAST_LOGON = "Last Logon Ship@Ease Web";
export const FORGOTTEN_YOUR_PASSWORD =
  "Forgotten your password? \n Request a reset password link below";
export const SUBMIT = "Submit";
export const BACK = "Back";
export const FORGOT_PASSWORD = "Forgot password?";
export const NO_USERS = "No users available to display";
export const ADD_NEW_USER = "Add new user";
export const PERMISSION_CREATE_DPD_USER = "Permission to create DPD users";
export const PERMISSION_TO_MANAGE_MYDPD_APP = "Permission to manage MyDPD app";
export const PERMISSION_CREATE_MASTER_USER =
  "PERMISSION TO CREATE MASTER USERS";
export const CREATE_DPD_USER = "Create DPD user";
export const CREATE_MASTER_USER = "Create master user";
export const VIEW_INVITED_USERS = "VIEW INVITED USERS";
export const NO_USERS_TO_SHOW = "No users to show in this view";
export const BACK_TO_RESULT = "BACK TO RESULTS";
export const NOTE_EXPIRY_USER = "Note: this user will expire at midnight on";
export const MY_DPD_USER_ALREADY_CREATED =
  "A temporary master user has already been created for MyDPD";
export const CREATE_USER = "Create User";
export const SEARCH = "Search";
export const SYNC = "Sync";
export const PROFILE_MANAGEMENT = "Profile Management";
export const CUSTOMER_MIGRATION = "Customer Migration";
export const CUSTOMER_SETTINGS = "Customer Settings";
export const DPD_APP_CONFIG_MENU = "APP Management";
export const NO_AUDIT_LOGS = "No audit logs available";
export const LOGON_ID = "Logon ID";
export const SYNC_MYDPD_APP = "Sync MyDPD Application Version:";
export const SYNC_MYDPD_LOCAL_APP = "Sync MyDPD Local Application Version:";
export const ACCOUNT_NUMBER = "Account Number";
export const BATCH_ACCOUNTS = "Batch Accounts (ID*BU CSV)";
export const SWITCH_ACCOUNT = "Switch Account";
export const ACCOUNT_IS_SUSPENDED = "Account is suspended";
export const CONFIRMATION_PASSWORD_RESET =
  "The user has been sent an email with instructions on how to reset their password";
export const CONFIRMATION_FORGOT_PASSWORD =
  "An email with instructions on how to reset your password has been sent";
export const CONFIRMATION_CREATE_NEW_USER =
  "The user has been created and they have been sent an account activation email";
export const TITLE = "Title";
export const POSITION = "Position";
export const FIRST_NAME = "First Name";
export const SURNAME = "Surname";
export const TEL_NUMBER = "Tel Number";
export const DESCRIPTION = "Description";
export const CHOOSE_AUTOGENERATED_USERNAME = "Choose auto-generated username";
export const USERNAME = "Username";
export const INVALID_PHONE_NOT_A_VALID_PHONE_NUMBER =
  "Not a valid phone format";
export const PASSWORD = "Password";
export const CONFIRM_PASSWORD = "Confirm Password";
export const LOGON_DETAILS = "Logon details";
export const BUSINESS_ID = "Business ID";
export const DPD = "DPD";
export const DPD_LOCAL = "DPD Local";
export const DPD_APP_CONFIG = "DPD APP CONFIG";
export const DPD_APP_VERSIONS = "DPD APP VERSIONS";
export const POSTCODE = "Postcode";
export const STREET = "Street";
export const SUBURB = "Suburb";
export const CITY = "City";
export const COUNTY = "County";
export const COUNTRY = "Country";
export const COMPANY = "Company";
export const UK = "United Kingdom";
export const RIA = "Republic of Ireland";
export const NOTIFICATION_EMAIL = "Notification Email";
export const NOTIFICATION_TEL = "Notification Tel";
export const OVERRIDE_ACCOUNT_ADDRESS = "Override Account's Address";
export const COLLECTION_SHIP_EASE = "Collections and ship@ease";
export const REPORTS = "Reports";
export const DELIVERY_DASHBOARD_EXCEPTIONS = "Delivery Dashboard/Exceptions";
export const DISABLE_COLLECTION_ALLOW_REVIEW =
  "Disable collection, allow Review IT";
export const DISABLE_PAPERLESS_TRADING_LABEL = "Disable paperless trading";
export const EXTRACT_REPORTS = "Extract reports";
export const FLIGHT_DELIVERY_ACTIONS = "In Flight Delivery Actions";
export const ADMIN_ACCESS_TO_CUSTOMER_PROFILES =
  "Admin access to customer profiles";
export const DESCRIPTION_AND_MORE = "Description, and more";
export const SHARE_MY_SHIPMENTS_BY_ACCOUNT =
  "Share my shipments with other users by Account";
export const SHARE_MY_SHIPMENTS_BY_PROFILE =
  "Share my shipments with other users by Profile";
export const ALLOW_OTHER_TO_EDIT_MY_SHIPMENTS =
  "Allow other users to edit my shipments";
export const INCLUDE_SHIPMENT_RACED_BY_OTHERS =
  "Include shipments raised by others";
export const SHARE_MY_COLLECTION = "Share my collections with other users";
export const INCLUDE_COLLECTIONS_RAISED_BY_OTHERS =
  "Include collections raised by other users";
export const RESTRICT_DELIVER_ALTERNATIVE_ADDRESS =
  "Restrict redeliver to alternative address";
export const RESTRICT_UPGRADE_ACTIONS = "Restrict Upgrade Actions";
export const USE_JAVA_APPLET = "Use Java Applet";
export const READ_ONLY_ADDRESS_BOOK = "Read only address book";
export const READ_ONLY_PRODUCT_BOOK = "Read only product book";
export const NO_THIRD_PARTY_COLLECTIONS = "No third party collections";
export const THIRTY_DAYS_FORWARD_DATING = "30 Days Forward Dating";
export const DISABLE_NOTIFICATION_ON_PRINT = "Disable Notification on Print";
export const NO_MANUAL_ADDRESS_ENTRY = "No manual address entry";
export const NO_MANUAL_CONTACT_DETAILS_ENTRY =
  "No manual contact details entry";
export const REFERENCE_ONE_READ_ONLY = "Reference 1 read only";
export const SHIPMENTS = "Shipments";
export const COLLECTIONS = "Collections";
export const CHANGE_DELIVERY = "Change delivery";
export const NONE = "None";
export const LIMIT_COLLECTIONS_USER =
  "Limit Collections to those created by this user";

export const INITIAL_CURRENCY = {
  currencyCode: NONE,
  currencyDescription: NONE,
};

export const CUSTOMER_MISCELLANEOUS_CONFIGURATION_TABS = [
  {
    label: "SHIPMENTS",
    analyticsId: ANALYTICS_FOR_USER.CLICK_SHIPMENTS,
  },
  {
    label: "COLLECTIONS",
    analyticsId: ANALYTICS_FOR_USER.CLICK_COLLECTIONS,
  },
];

export const MISCELLANEOUS_CONFIGURATION_TABS = [
  ...CUSTOMER_MISCELLANEOUS_CONFIGURATION_TABS,
  {
    label: "CHANGE DELIVERY",
    analyticsId: CREATE_EDIT_CUSTOMER_USER_ANALYTICS.CLICK_CHANGE_DELIVERY,
  },
  {
    label: "USE JAVA APPLET",
    analyticsId:
      CREATE_EDIT_CUSTOMER_USER_ANALYTICS.CLICK_THERMAL_PRINTER_INTERFACE,
  },
];

export const ADDRESS_BOOK = "Address Book";
export const PRODUCT_BOOK = "Product Book";
export const CREATE_SHIPMENT = "Create Shipment";
export const COLLECTION = "Collection";
export const ADHOC_FORWARD_DATING = "Ad-hoc forward dating";

export const CUSTOMER_ADVANCED_CONFIGURATION_TABS = [
  {
    label: ADDRESS_BOOK,
    analyticsId: ANALYTICS_FOR_USER.CLICK_ADDRESS_BOOK,
  },
  {
    label: PRODUCT_BOOK,
    analyticsId: "",
  },
  {
    label: CREATE_SHIPMENT,
    analyticsId: ANALYTICS_FOR_USER.CLICK_CREATE_SHIPMENT,
  },
  {
    label: COLLECTION,
    analyticsId: ANALYTICS_FOR_USER.CLICK_COLLECTION,
  },
];

export const ADVANCED_CONFIGURATION_TABS = [
  ...CUSTOMER_ADVANCED_CONFIGURATION_TABS,
  {
    label: ADHOC_FORWARD_DATING,
    analyticsId: CREATE_EDIT_CUSTOMER_USER_ANALYTICS.CLICK_FORWARD_DATING,
  },
];

export const EXPAND_ALL = "Expand All";
export const COLLAPSE_ALL = "Collapse All";
export const GO_AWAY_MESSAGE =
  "Are you sure you want to\nnavigate away from this page,\nany unsaved changes will be lost";

export const SEARCH_TABLE_HEADERS = [
  "LOGON ID",
  "ACCOUNT",
  "FORENAME",
  "SURNAME",
  "",
];

export const SUSPEND_DELETE_USER_COLUMN = "suspendDeleteUserColumn";

export const AUDIT_TABLE_HEADERS = ["EDITOR LOGON", "AUDIT TYPE", "DATE"];

export const REFERENCES = "References";
export const FAILED_IMPORT = "Failed import";
export const END_OF_DAY = "End of day";
export const GROUP_DISPATCH = "Group dispatch";
export const BULK_REVERSE_IT = "Bulk reverse-it";

export const SENDERS_REFERENCE_ONE = "Sender's Reference 1 is mandatory";
export const SENDERS_REFERENCE_TWO = "Sender's Reference 2 is mandatory";
export const SENDERS_REFERENCE_THREE = "Sender's Reference 3 is mandatory";
export const ENSURE_REFERENCE_UNIQUE = "Ensure Sender's Reference 1 is unique";
export const ENABLE_SCANNING_SCREEN = "Enable scanning screen";
export const ALLOCATE_SENDERS_REFERENCE =
  "Allocate Sender's Reference 1 if empty during data import";
export const UPDATE_RECORDS_WITH_DUPLICATE =
  "Update records with duplicate Sender's Reference 1 if not printed";
export const USE_BAD_FILE = "Use bad file";
export const USE_SCREEN = "Use screen";
export const SHOW_EXPIRATION_DATE_ON_LABEL =
  "Show Expiration Date on Label (6 inch labels required)";
export const ENABLE_BULK_REVERSE = "Enable Bulk Reverse-it";
export const ENABLE_FOUR_INCH_REVERSE = "Enable 4 inch Reverse-it label";

export const END_OF_DAY_DASHED = "End-of-Day";
export const EOD_WARNING =
  'If selected enables "Disable Notifications on Print".\nIf disabling EOD please ensure EOD is run first on MyDPD.';
export const EOD_TIME_WARNING =
  "Please note: If International Air Service used auto time must be before 9pm.";
export const EOD_TIME = "Auto EOD Time";
export const EOD_TIME_DEFAULT = "Please select a time";
export const EOD_DAYS = "Auto EOD Days";
export const EOD_HOLD_EVERYTHING = "Hold Everything";
export const EOD_ENABLE_RELEASE_FILE = "Enable Release File";
export const EOD_DISABLE_PRINT = "Disable A4 Manifest Print Out";
export const EOD_EXTENDED_TITLE = "Enable hold for 1 year";
export const EOD_EXTENDED_HOLD = "Extend Hold";
export const EOD_MASTER_TITLE = "MASTER EOD";
export const EOD_MASTER = "Enable Master EOD";
export const EOD_MASTER_WARNING =
  "Before enabling Master EOD please ensure the below settings are selected on all logins for this account:";
export const EOD_MASTER_WARNING_ROWS = [
  "- Share my shipments with other users by profile",
  "- Allow other users to edit my shipments",
  "- End-of-Day",
];
export const EOD_MASTER_WARNING2 = "For the Master EOD also select:";
export const EOD_MASTER_WARNING2_ROWS = [
  "- Include shipments raised by other users",
  "- Disable A4 manifest print out",
];

export const MONDAY = "Monday";
export const TUESDAY = "Tuesday";
export const WEDNESDAY = "Wednesday";
export const THURSDAY = "Thursday";
export const FRIDAY = "Friday";
export const SATURDAY = "Saturday";
export const SUNDAY = "Sunday";

export const WEEKDAY_OPTIONS = [
  { label: MONDAY, value: 1 },
  { label: TUESDAY, value: 2 },
  { label: WEDNESDAY, value: 3 },
  { label: THURSDAY, value: 4 },
  { label: FRIDAY, value: 5 },
  { label: SATURDAY, value: 6 },
  { label: SUNDAY, value: 0 },
];

export const DISABLE_ADHOC_EDIT = "Disable Adhoc/Edit Shipment";
export const DISABLE_ADD_EXTRA_LABEL = "Disable Add Extra Label";
export const DISABLE_IMPORT_FILE_SETUP = "Disable Import file setup";
export const DISABLE_EXPORT_FILE_SETUP = "Disable Export file setup";
export const DISABLE_EXTENDED_LIABILITY = "Disable Extended Liability";
export const WARNING_TEXT_GENERATE_TOKEN =
  "Please populate account number and username";
export const SECURITY_SETTINGS_WARNING_ONE =
  "If 'Disable Adhoc/Edit Shipment' is selected, do not allow user to select Failed Imports Screen.";
export const SECURITY_SETTINGS_WARNING_TWO =
  "Please select 'Use Bad File' in 'Failed Import' option.";
export const PLEASE_ENSURE_PERMISSION =
  "Please ensure permission is granted by your account manager to switch on this feature";
export const MAPPING = "Mapping";
export const CLEAR_ALL = "Clear all >";
export const MAPPING_DESCRIPTIONS = "Mapping Descriptions";
export const DEFAULT_SERVICE = "Default Service";
export const SERVICE_SELECT_DEFAULT = "Please select";
export const ADD_ALL = "Add all>";
export const REMOVE_ALL = "Remove all >";
export const SPECIAL_SERVICES = "SPECIAL SERVICES";
export const DPD_SERVICE_LEFT_HEADER = "Available Services";
export const DPD_SERVICE_RIGHT_HEADER = "Excluded Services";
export const USER_PROFILES_LEFT_HEADER = "Allocated Profiles";
export const USER_PROFILES_RIGHT_HEADER = "Un-Allocated Profiles";
export const USER_PROFILES_NO_ACCOUNT_IS_SELECTED =
  "No Account is selected so there are no Profiles to view - Please select an Account.";
export const USER_PROFILES_NO_PROFILE_LINKED =
  "There are no Profiles associated with this Account, you will not be able to create a new user";
export const NO_USER_WITH_CURRENT_ID = "No user with this id found";
export const NO_PROFILE_WITH_CURRENT_ID = "No profile with this id found";

export const SERVICE_EXCLUSIONS_TABS = [
  {
    label: "DPD",
    analyticsId: ANALYTICS_FOR_USER.CLICK_DPD_SERVICE_EXCLUSIONS,
  },
  {
    label: "DPD LOCAL",
    analyticsId: ANALYTICS_FOR_USER.CLICK_DPD_LOCAL_SERVICE_EXCLUSIONS,
  },
];
export const USE_ROAD_SERVICE = "Use Road service instead of Air if available";
export const REFERENCE_IN_CUSTOMER_ZONE = "REFERENCE IN CUSTOMER ZONE";
export const REFERENCE_IN_CUSTOMER_ZONE_AS_BARCODE =
  "REFERENCE IN CUSTOMER ZONE AS BARCODE";
export const HOMECALL_LABEL_PREFERENCE = "Homecall label preference";
export const USE_6_INCH_LABELS = "Use 6 inch labels";
export const INCLUDE_TRACKING_BARCODE = "Include tracking barcode";
export const INCLUDE_CUSTOMER_CODE = "Include customer code";

export const REFERENCE_IN_CUSTOMER_ZONE_ITEMS = [
  { title: "Reference 1", value: "1" },
  { title: "Reference 2", value: "2" },
  { title: "Reference 3", value: "3" },
  { title: "None", value: "0" },
];
export const REFERENCE_IN_CUSTOMER_ZONE_BARCODE_ITEMS = [
  { title: "Reference 1", value: "1" },
  { title: "Reference 2", value: "2" },
  { title: "Reference 3", value: "3" },
  { title: "None", value: "0" },
];
export const HOMECALL_LABEL_PREFERENCE_ITEMS = [
  { title: "Reference", value: "0" },
  { title: "Reference barcode", value: "1" },
  { title: "Tracking barcode", value: "2" },
  { title: "Customer code", value: "3" },
];

export const SELECTOR = "Selector";
export const SECTOR = "Sector";
export const RESTRICTION = "Restriction";

export const ADD_REPLACE_DAY = "Add/Replace and set to 2 Day:";
export const IRISH_CODES = "Irish codes";
export const OFFSHORE_CODES = "Offshore codes";
export const HIGHLANDS_AND_ISLAND_CODES = "Highlands and island codes";

export const CREATE_NEW_PROFILE = "CREATE NEW PROFILE";
export const EDIT_PROFILE = "EDIT PROFILE";
export const SEARCH_PROFILE_TABLE_HEADERS = [
  "PROFILE CODE",
  "PROFILE NAME",
  "ACCOUNT #",
  "",
];
export const PROFILE_NAME = "Profile Name";
export const PROFILE_CODE = "Profile Code";
export const DUPLICATE_PROFILE = "Duplicate Profile";
export const DELETE_PROFILE = "Delete Profile";

export const ACCOUNT = "Account";
export const PREFERENCES = "Preferences";
export const DEFAULTS = "Defaults";
export const INT_INVOICE = "Int. invoice";
export const ADDRESS = "Address";

export const SAFE_PROFILE = "Save profile";
export const INTERNATIONAL = "International";
export const NO_EDIT_PROFILE = "No - Edit Profile";

export const PROFILE_ACCOUNT_TABS = [DPD, INTERNATIONAL, DPD_LOCAL];
export const DOMESTIC_OUTBOUND_SLID = "Domestic Outbound SLID";
export const EXCHANGE_OUTBOUND_SLID = "Exchange Outbound SLID";
export const EXCHANGE_INBOUND_SLID = "Exchange Inbound SLID";
export const EXPRESS_ACCOUNT_NUMBER = "Express Account Number";
export const EXPRESS_SLID = "Air/Lite SLID";
export const CLASSIC_SLID = "Classic SLID";
export const DIRECT_SLID = "Direct SLID";
export const CLASSIC_ACCOUNT_NUMBER = "Classic Account Number";
export const DIRECT_ACCOUNT_NUMBER = "Direct Account Number";

export const ACCOUNT_HAS_TO_BE_PRESENT = "Account number has to be present";
export const ACCOUNT_IS_INVALID = "Account number is invalid";
export const PROFILES_NOT_FOUND =
  "No Profiles found for the provided account number";
export const CONFIRM_DELETE_PROFILE =
  "Are you sure you want to delete this profile?";
export const INVALID_ACCOUNT = "Invalid account";
export const FILL_LABEL_NUMBERS =
  "Please fill in ‘Current Label No.’ for ALL SLIDS for saving profile";
export const FOUND_SLIDS_FIX =
  "The following SLIDs were found in use by other accounts. \n\nPlease ensure that the SLIDs are unique before saving the profile:";
export const FOUND_SLIDS_FIX_CONTACT =
  "For assistance please contact: edisupport@dpdgroup.co.uk";
export const NEW_SLIDS = "NEW SLID DETAILS";
export const FOUND_SLIDS = "FOUND SLIDS IN USE";
export const CURRENT_LABEL_NO = "Current Label No";
export const INVALID_FIELD_VALUE = "Invalid field value {0}";
export const DUPLICATE_PROFILE_FROM =
  "Create a new profile by\n copying from:\n {0}, Acc No. {1}";
export const DELETE_PROFILE_MESSAGE =
  "Are you sure you want to\n delete Profile - {0},\n Acc No. {1}?";

export const ENABLE_AIR_EXPRESS_PARCEL =
  "Enable Air Express Parcel (10,30,50,70)";
export const ENABLE_DPD_CLASSIC_PARCEL = "Enable DPD Classic Parcel (19)";
export const ENABLE_DPD_DIRECT_PARCEL = "Enable DPD Direct Parcel (58,80)";
export const ENABLE_DPD_CLASSIC_PARCEL_FREIGHT =
  "Enable DPD Classic Parcel - Freight(89)";
export const ENABLE_AIR_CLASSIC_PARCEL = "Enable Air Classic Parcel (60)";
export const ENABLE_DPD_SMALL_PARCEL = "Enable DPD Small Parcel (39)";
export const ENABLE_DPD_CLASSIC_PALLET = "Enable DPD Classic - Pallet (79)";
export const ENABLE_DPD_DIRECT_LITE = "Enable DPD Direct Lite (20)";

export const USE_MY_DPD_SHIPPING_DEFAULTS = "Use MyDPD Shipping Defaults - ";
export const DO_NOT_USE_MULTI_BUSINESS_UNIT =
  "Do not use this in the case of Multi Business Unit";
export const WEIGHT = "Weight";
export const DEFAULT_INFORMATION = "Default information\n(Max. 50 characters)";
export const DPD_LOCAL_INTERNATIONAL = "DPD Local International";
export const OUTBOUND_SERVICE = "Outbound Service";
export const DOMESTIC_OUTBOUND_SERVICE = "Domestic Outbound Service";
export const EXCHANGE_OUTBOUND_SERVICE = "Exchange Outbound Service";
export const EXCHANGE_RETURN_SERVICE = "Exchange Return Service";
export const OFFSHORE_OUTBOUND_SERVICE = "Offshore Outbound Service";
export const OFFSHORE_EXCHANGE_SERVICE = "Offshore Exchange Service";
export const PLEASE_SELECT_SERVICE = "Please select a service";
export const SELECT_IP_ADDRESS = "Select IP Address";
export const NO_IP_ADDRESSES_AVAILABLE = "No IP addresses available";
export const SHIPPERS_DETAILS = "Shippers details";
export const COMPANY_NAME = "Company Name";
export const SEARCH_TERM = "Search Term";
export const ADDRESS_LINE_1 = "Address Line 1";
export const ADDRESS_LINE_2 = "Address Line 2";
export const ADDRESS_LINE_3 = "Address Line 3";
export const ADDRESS_LINE_4 = "Address Line 4";
export const DEFAULT_CURRENCY = "Default Currency";

export const ALL = "All";
export const INACTIVE = "Inactive";
export const INVITED_USERS = "INVITED USERS";
export const SUSPENDED = "Suspended";
export const PREVIOUS_PAGE = "Previous Page";
export const NEXT_PAGE = "Next Page";

export const SHIPPERS_EORI_NUMBER = "Shippers EORI Number";
export const FDA_REGISTRATION_NO = "FDA Registration No";
export const SHIPPERS_VAT_NUMBER = "Shippers VAT Number";
export const DESTINATION_TAX_ID_NUMBER = "Destination Tax ID/Req No";
export const DEFAULT_FOR_EXTENDED_LIABILITY = "Default for Extended Liability";
export const EXPORT_INVOICE_REQUIRED = "Export Invoice Required";
export const INVOICE_TYPE = "Invoice Type";
export const SELECT_EACH_TIME_INVOICE = "Select each time invoice is required";
export const GENERATE_INVOICE_ONLINE = "Generate Invoice Online";
export const CREATE_OWN_INVOICE = "Create Own Invoice";
export const COMMERCIAL = "Commercial";
export const PROFORMA = "Proforma";
export const UK_IMS_NUMBER = "UKIMS Number";
export const UK_IMS_NUMBER_LENGTH_MUST_BE =
  "UKIMS Number length must be equal 32";
export const PAGE_HEADER = "Page Header";
export const WHEN_NOT_USING_LETTERHEAD_PAPER =
  "(When not using letterhead paper Max 255 Characters)";
export const ARE_YOU_SURE_YOU_WANT_TO_UPDATE_USER =
  "Are you sure you want to update this user’s details?";

export const SHARE_MY_COLLECTION_INFO =
  "Other users (which have been configured) that belong to this same account will be able to see collections raised by this user";
export const INCLUDE_COLLECTIONS_BY_OTHER_INFO =
  "When querying collections, include those raised by other users (those that have been configured to share)";
export const LIMIT_COLLECTIONS_USER_INFO =
  "When creating collections, only the user who created them will be able to see them";

export const SHARE_SHIPMENTS_BY_ACCOUNT_PROFILE_INFO =
  "Other users (which have been configured) that belong to this same account will be able to see shipments raised by this user";
export const ALLOW_OTHER_TO_EDIT_MY_SHIPMENTS_INFO =
  "Allow other users to edit my shipments";
export const INCLUDE_SHIPMENT_RACED_BY_OTHERS_INFO =
  "When querying shipments, include those raised by other users (those that have been configured to share)";
export const RESTRICT_REDELIVER_INFO =
  'User is not allowed access to the redeliver to alternative address option when requesting a "change delivery" on a parcel';
export const RESTRICT_UPGRADE_ACTIONS_INFO =
  "User is not allowed access to the parcel upgrade actions";
export const USE_JAVA_APPLET_INFO =
  "Allows a user to print thermal labels on a browser that is not Internet Explorer";

export const COLLECTIONS_AND_SHIP_EASE_INFO =
  "This enables users to have access to the collections tab and creating a shipment";
export const DISABLE_COLLECTION_ALLOW_REVIEW_INFO =
  "This disables user access to everything within the collections tab other than \nReview It";
export const REPORTS_INFO = "Allows the user to see the reports tab";
export const EXTRACT_REPORTS_INFO =
  "Allows the user to see Extract deliveries button";
export const DELIVERY_DASHBOARD_EXCEPTIONS_INFO =
  "Allows the user to see the exceptions tab";
export const REQUIRED_API_INTEGRATION =
  "This is required for logging in if you use our API Integration";
export const IN_FLIGHT_DELIVERY_ACTIONS_INFO =
  "Allows a user to change \ninflight delivery actions through tracking";
export const ADMIN_ACCESS_ACTIONS_INFO =
  "Make this user an admin \non the Customer UMS Portal";
export const USE_ROAD_SERVICE_INFO =
  "This enables shipments to be restricted to use road services only when possible";
export const POPULATE_EMAIL_MSG =
  "Please ensure the email address field is populated";
export const ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT =
  "Are you sure you want\nto sign out?";
export const ADMIN_FIRST_LOGIN_MSG =
  "Before creating and managing users, we suggest that you head to the team settings page to set up IP Restrictions, Auto Account Suspend and more";
export const ARE_YOU_SURE_THESE_USERS = "Are you sure you want to {0} {1}?";
export const ARE_YOU_WANT_DELETE = "Are you sure you want to delete {0}?";
export const THIS_USER = "this user";
export const THESE_USERS = "these users";
export const SUSPEND = "suspend";
export const UNSUSPEND = "unsuspend";
export const LOGIN = "Login";
export const RE_ENTER_PASSWORD = "Re-enter Password";
export const USE_EMAIL_AS_LOGIN = "Use this email address as the login";
export const SET_USER_EXPIRY_DATE = "Set user expiry date";
export const ENTERED_WEIGHT_HAS_TO_BE_AN_INTEGER =
  "Entered weight has to be an integer";
export const PLEASE_ENTER_A_VALID_VALUE_THE_TWO_NEAREST_VALID_VALUES =
  "Please enter a valid value. The two nearest valid values are: {0} and {1}";

export const PASSWORD_STRENGTH = {
  EMPTY_PASSWORD: -1,
  WEAK_PASSWORD: 0,
  UNSAFE_PASSWORD: 2,
  GOOD_PASSWORD: 3,
  STRONG_PASSWORD: 4,
};

export const PASSWORD_STRENGTH_LABELS = {
  WEAK_PASSWORD: "Weak Password",
  STRONG_PASSWORD: "Strong Password",
  GOOD_PASSWORD: "Could be stronger",
};

// Webhooks

// Titles
export const WEBHOOKS = "Webhooks";
export const WEBHOOK_LABEL = {
  notification: "Notifications",
  event: "Events",
};

// Configuration
export const GENERATE_NEW_SECRET = "Generate New Secret";
export const ENABLE_WEBHOOK_DETAILS = "Enable Webhook Details";
export const WEBHOOK_DETAILS = "Webhook Details";
export const PROVIDE_US_WITH_YOUR_URL = "Provide us with your URL:";
export const ENTER_URL_HERE = "Enter a URL here";
export const URL_REQUIRED_WHEN_WEBHOOK_ENABLED =
  "Please enter a valid URL to enable webhooks";

// Notification/Event access
export const ACCESS = "Access";
export const CONFIGURE_WEBHOOK = "Configure Webhook";

// Shared secrets
export const REVOKE = "Revoke";
export const CONFIRM_DISABLING_SHARED_SECRET =
  "Confirm Disabling Your Shared Secret?";
export const DISABLING_SHARED_SECRET =
  "Disabling this secret will immediately stop all webhooks that are currently using it.";
export const SECRET_SAFETY_MEASURE =
  "As a safety measure, we'll keep the secret deactivated for 30 days before permanently deleting it. If you need to reactivate it within this timeframe, please contact our IT Service Desk on 0121 500 2510.";
export const ENTER_DELETE_TO_CONFIRM =
  "To revoke this webhook please enter 'Revoke':";
export const REVOKE_SHARED_SECRET_PLACEHOLDER = "Enter 'Revoke' to confirm";
export const REVOKE_SHARED_SECRET = "Revoke Shared Secret";

// Suspended secrets
export const SUSPENDED_ACCESS = "Suspended Access";
export const MANAGE_SUSPENDED_SECRETS = "Manage Suspended Secrets";
export const REACTIVATE = "Reactivate";
export const SUSPENDED_SECRETS_DETAILS = "Suspended Secrets Details";
export const CREATED_AT = "Created At";
export const SUSPENDED_DATE = "Suspended Date";

// Test Webhook Form
export const TEST_WEBHOOK = (webhookType) =>
  webhookType === "notification" ? "Test Notifications" : "Test Events";
export const SIMULATE_TYPE_WEBHOOKS = (webhookType) =>
  `Simulate ${capitalize(webhookType)} Webhooks`;
export const DETAILS_FOR_TESTING = "Details for Testing";
export const TO_SEND_TEST_MESSAGE =
  "To send a test, you must enter an Email or SMS";
export const SELECT_WEBHOOK = (webhookType) =>
  `Select ${webhookType?.charAt(0).toUpperCase() || ""}${
    webhookType?.slice(1) || ""
  }`;
export const EMAIL = "Email";
export const SMS = "SMS";
export const TEST_URL = "Test URL";
export const SECRET = "Secret";
export const YOUR_SECRET = "Your secret";
export const PLEASE_CREATE_SECRET_TO_SEND_TEST =
  "Please create a secret to send a test";

export const TEST_EVENT_CODE = {
  Deliveries: "001",
  Collections: "DPA",
};

export const WEBHOOK_EVENT_CATEGORY = {
  Collections: "COL",
  Deliveries: "DEL",
};

export const WEBHOOK_EVENT_INFO_LABELS = {
  Collections: {
    ALL: "A webhook is sent for every collection-related event.",
    "All Collection Events":
      "A webhook is sent for every collection-related event.",
    COL: "A webhook is sent only when the shipment is collected.",
    "Collection Collected Events":
      "A webhook is sent only when the shipment is collected.",
  },
  Deliveries: {
    ALL: "A webhooks is sent for every delivery-related event.",
    "All Parcel Events": "A webhooks is sent for every delivery-related event.",
    POD: "A webhook is sent only when the shipment is delivered.",
    "Parcel Delivered Events":
      "A webhook is sent only when the shipment is delivered.",
  },
};

export const WEBHOOK_NOTIFICATION_INFO_LABELS = {
  Delivered: {},
  "Out for delivery": {},
  DEFAULT:
    "Once enabled and saved, DPD will no longer send notifications to the shipment receiver for this status.",
};

export const WEBHOOK_ENABLE_INFO_LABELS = {
  NOTIFICATION:
    "Webhook Notifications inform the sender when a shipment reaches an Out for Delivery or Delivered status.",
  EVENT:
    "Webhook Events provide status updates as the shipment progresses through the DPD network.",
};

// Terms and Conditions
export const WEEBHOOKS_TERMS_AND_CONDITIONS =
  "By enabling webhooks, you agree to the Terms & Conditions.";
export const WEBHOOKS_TERMS_AND_CONDITIONS_URL =
  "https://www.dpd.co.uk/api-webhooks.jsp";
export const WEBHOOKS_API_PORTAL_URL =
  "https://developers.api.dpd.co.uk/webhooks/introduction";
export const FOR_DETAILS = "for details.";
export const CLICK_HERE = "Click here";
export const API_PORTAL = "API Portal";
export const WEBHOOKS_API_PORTAL_INFO =
  "Please visit the API Portal for more information on the Webhooks service.";

// API Logic
export const WEBHOOK_TYPES = {
  NOTIFICATION: "notification",
  EVENT: "event",
};

// Snackbar Messages
export const WEBHOOK_SNACKBAR_MESSAGES = {
  SECRET_GENERATED_SUCCESS: "Secret generated successfully",
  SECRET_GENERATION_FAILED: "Failed to generate secret",
  SECRET_SUSPENDED: "Secret Suspended",
  SECRET_REVOKE_FAILED: "Failed to revoke secret",
  PREFERENCES_UPDATED_SUCCESS: "Preferences updated successfully",
  PREFERENCES_UPDATE_FAILED: "Failed to save changes. Please try again",
  NO_WEBHOOK_DATA_FOUND:
    "No webhook data found for the specified account number",
  ERROR_SEARCHING_WEBHOOK_DATA: "Error searching for webhook data",
  SECRET_REACTIVATED_SUCCESS: "Secret reactivated successfully",
  SECRET_REACTIVATE_FAILED: "Failed to reactivate secret",
  ACCOUNT_NUMBER_AND_TYPE_REQUIRED: "Account number and type are required",
  TEST_SENT_SUCCESS: "Test successfully sent",
  TEST_SEND_FAILED: "Failed to send test",
};

export const ACTIVITY_MONITOR = "Activity Monitor";
export const MANAGE_USERS = "Manage Users";
export const TEAM_SETTINGS = "Team Settings";
export const USER_EXPIRES_ON = "User expires on";

export const IP_ACCESS = "Ip Access";
export const ENTER_IP_ADDRESS = "Enter IP Address";
export const IP_ADDRESS_NAME = "IP Address Name  (Optional)";
export const PERMITTED_IP_ADDRESSES = "Permitted IP Addresses";
export const AUTO_SUSPEND_ACCOUNTS = "Auto suspend accounts";
export const ACCOUNTS_WILL_BE_SUSPENDED_FOR =
  "Accounts will be suspended if user has been inactive for ";
export const DAYS = "days";

export const SUSPENDED_DAYS_30 = 30;
export const SUSPENDED_DAYS_90 = 90;
export const SUSPENDED_DAYS_60 = 60;

export const IP_ALREADY_ADDED = "IP address already added";
export const SAVE_SETTINGS = "Save Settings";

export const ARE_YOU_SURE_DELETE_IP_ADDRESS =
  "Are you sure you want to delete this IP Address?";
export const PLEASE_NOTE = "Please note:";
export const DELETE_IP_NOTE =
  "This change will affect all users within this account";

export const INVALID_IP = "Entered IP address is invalid";
export const INVALID_START_IP = "Entered Start IP is invalid";
export const INVALID_END_IP = "Entered End IP is invalid";

export const GOOGLE = "GOOGLE";

export const GOOD_NEWS = "Good news";
export const NO_INACTIVE_USERS = "You have no inactive users!";
export const INACTIVE_USER_DAYS = 30;

export const IP_RANGE = "IP Range";
export const START_IP = "Start IP";
export const END_IP = "End IP";
export const IP_RANGE_NAME = "IP Range Name  (Optional)";
export const IP_RANGE_ALREADY_ADDED = "IP range already added";
export const ENTERED_IP_RANGE_INVALID = "Entered IP range is invalid";

export const GB = "GB";
export const IE = "IE";
export const COUNTRY_CODES = [GB, IE];
export const COUNTRY_CODES_DESCRIPTION = {
  GB: "United Kingdom",
  IE: "Republic of Ireland",
};

export const YOUR_TEAMS_ACTIVITY = "Your team's activity";
export const CHOOSE_DATE = "Choose a date";
export const NO_RESULTS_FOUND = "No results found";
export const PLEASE_SEARCH_AGAIN = "Please search again";
export const SEARCH_USERS = "Search Users";

export const HIDE_DETAILS = "Hide details";
export const SEE_DETAILS = "See details";

export const ENSURE_ALL_FIELDS_POPULATED =
  "Please ensure all mandatory fields are populated";

export const PAGE_NOT_FOUND = "Page not found";
export const PAGE_HAS_NOT_BEEN_FOUND =
  "Oops, the page you are looking for has not been found";
export const HOME = "Home";

export const STORE_SHIPMENTS_SIX_MONTHS = "Store shipments for 6 months";
export const ENABLE_BY_AUTOMATION_TEAM =
  "This can only be enabled by the Automation Team as this is a DPD feature ONLY that required a SLID and is not for general use";
export const PLEASE_CHECK_YOUR_INPUT = "Please check your input and try again";
export const ABOUT_TO_DELETE_KEY = "You are about to delete the following key";
export const ENTER_DELETE =
  "Please enter DELETE below to confirm deletion of the key. \n Please note, this action cannot be reverted.";
export const VIEW_KEY_INFORMATION = "View your key information below";
export const SECRET_SHOWN_ONCE =
  "Please note, your secret is only shown once. Please make sure you copy and save it to your computer before closing this pop up.";
export const ABOUT_DISABLE_API_ACCESS =
  "You are about to disable API access on this account. This will remove all keys from this account";
export const ENTER_DISABLE =
  "Please enter DISABLE API ACCESS below to confirm disable API Access. \n Please note, this action cannot be undone.";
